import HealthAPI from 'dashboard/api/asterisk/health';

// Format timestamp to Brazilian format (DD/MM/YYYY HH:mm:ss)
// Input can be UTC or already local time from API
const formatTimestamp = timestamp => {
  if (!timestamp) return null;
  try {
    // Parse the timestamp - API returns format "YYYY-MM-DD HH:mm:ss"
    const date = new Date(timestamp.replace(' ', 'T') + 'Z'); // Assume UTC
    return date.toLocaleString('pt-BR', {
      timeZone: 'America/Sao_Paulo',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return timestamp;
  }
};

export const state = {
  data: null,
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getData: $state => $state.data,
  getUIFlags: $state => $state.uiFlags,
  isHealthy: $state => {
    const status = $state.data?.status;
    return status === 'ok' || status === 'healthy';
  },
};

export const actions = {
  async fetch({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await HealthAPI.get();
      // Rails controller returns: { success: true, health: { success, data: { status, timestamp } } }
      // Extract the nested data properly
      const healthResponse = response.data.health || response.data;
      const healthData = healthResponse.data || healthResponse;

      // Normalize the data structure
      const normalizedData = {
        status: healthData.status,
        database: healthData.database,
        version: healthData.version,
        timestamp: formatTimestamp(
          healthData.timestamp || healthResponse.timestamp
        ),
      };

      commit('SET_DATA', normalizedData);
      return normalizedData;
    } catch (error) {
      commit('SET_DATA', { status: 'error', healthy: false });
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_DATA($state, data) {
    $state.data = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
